export enum transactional{
    SPNC = 130
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/sponsor-transactional-source-type.enum.ts